import type { OrderStatusGroup } from '@tcr-erp/shared';
import { isOrderLockedForUser } from './orderHeaderActions';

/** Field tối thiểu cần để phân loại 1 dòng đơn khi "Huỷ nhiều" (TCR-1964 final review). */
export interface BulkCancelRow {
  _id: string;
  status_group?: OrderStatusGroup | string | null;
}

export interface BulkCancelPartition {
  /** id các đơn ĐỦ điều kiện gọi API huỷ. */
  cancelableIds: string[];
  /**
   * Số đơn bị loại vì khoá theo trạng thái (từ nhóm "Mới" trở đi) và người thao tác không có
   * `orders.override_lock` — xem `isOrderLockedForUser`.
   */
  lockedCount: number;
}

/**
 * TCR-1964 final review — `Orders/index.tsx` `handleBulkCancel` ("Huỷ nhiều") trước đây gọi API
 * huỷ cho MỌI dòng đã chọn, kể cả đơn đã bị khoá theo trạng thái. BE sẽ trả 400
 * `ORDER_STATUS_LOCKED` cho từng đơn đó — không sai, nhưng người dùng chỉ thấy "N đơn thất bại"
 * mà không biết TẠI SAO. Tách phần lọc thành hàm thuần (không đụng antd Modal/mutation) để
 * unit-test độc lập, và để nơi gọi loại các đơn khoá RA TRƯỚC khi gọi API, đồng thời báo rõ số
 * lượng bị bỏ qua.
 */
export function partitionOrdersForBulkCancel(
  rows: BulkCancelRow[],
  canOverrideLock: boolean,
): BulkCancelPartition {
  const cancelableIds: string[] = [];
  let lockedCount = 0;
  for (const row of rows) {
    if (isOrderLockedForUser(row.status_group, canOverrideLock)) {
      lockedCount += 1;
    } else {
      cancelableIds.push(row._id);
    }
  }
  return { cancelableIds, lockedCount };
}
